import { render, staticRenderFns } from "./agentTransfer.vue?vue&type=template&id=5dbb0cc2&scoped=true&"
import script from "./agentTransfer.vue?vue&type=script&lang=js&"
export * from "./agentTransfer.vue?vue&type=script&lang=js&"
import style0 from "./agentTransfer.vue?vue&type=style&index=0&id=5dbb0cc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbb0cc2",
  null
  
)

export default component.exports